import { HpDiagnosisStepV3 } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, QueryList, ViewChildren, computed, signal } from '@angular/core';
import { SvgComponent } from '@app/components/svg/svg.component';
import { YesNoButtonsComponent } from './yes-not-buttons/yes-no-buttons.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-hp-diagnosis-question',
  imports: [CommonModule, TranslocoPipe, YesNoButtonsComponent, SvgComponent, Button],
  templateUrl: './question.component.html',
  standalone: true,
  styleUrl: './question.component.scss',
})
export class HPDiagnosisQuestionComponent implements OnChanges {
  @Input({ required: true }) diagnosticStep: HpDiagnosisStepV3 | null | undefined;
  @Input() isFollowUp = false;
  @Input() isLastStep = false;
  @Input() isOpened = false;
  @Input() svgComponent: SvgComponent | undefined;
  @Output() onFinished = new EventEmitter();

  diagnosticStepType = computed(() => {
    return this.diagnosticStep?.type?.toString() || '';
  });

  @ViewChildren(HPDiagnosisQuestionComponent)
  childQuestions: QueryList<HPDiagnosisQuestionComponent> | undefined;

  yesNo = signal<boolean | undefined>(undefined);

  hasMoreQuestions = computed(() => {
    this.diagnosticStep?.type.toString();
    return this.diagnosticStep?.yesAnswer && this.diagnosticStep?.noAnswer;
  });

  ngOnChanges(): void {
    if (this.isOpened) {
      this.reset();
      this.paintPins();
    }
  }

  cleanQuestion(question: string | null | undefined) {
    if (!question) return '';
    return question.replace(/\[.*?\]/g, '');
  }

  answeredNo() {
    this.yesNo.set(false);
  }

  answeredYes() {
    this.yesNo.set(true);
  }

  paintPins() {
    this.svgComponent?.removeAllPins();

    // Paint multimeter points
    const isMultimeterQuestion = (this.diagnosticStep?.toolParameters as any)?.tool === 'multimeter';
    if (isMultimeterQuestion) {
      const multimeterPins = (this.diagnosticStep?.toolParameters as any)?.pins || [];
      multimeterPins.forEach((point: any, index: number) => {
        this.svgComponent?.showConnector(point.pinNameId, index === 0 ? 'red' : 'black');
      });
    }
  }

  finishStep() {
    this.onFinished.emit();
  }

  reset() {
    this.yesNo.set(undefined);
    this.childQuestions?.forEach((c) => c.reset());
  }
}
